import { Input, Modal, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CollectionSessionInfoForm from './CollectionSessionInfoForm';
import FuelDispenserVerificationTable from './FuelDispenserVerificationTable';
import SubmitFuelDispenserVerificationForm from './SubmitFuelDispenserVerification';
import FuelPumpLayout from './FuelPumpLayout';
import dayjs from 'dayjs';
import { useForm } from 'antd/es/form/Form';
import '../ViewInspectionData.scss';

interface IViewRecordedPricesModal {
  isModalOpen: boolean;
  onCancel: () => void;
  formData: any;
}

type IslandGrid = {
  islandId: string;
  islandNumber: number | null;
  cells: boolean[][];
  rows: number;
  cols: number;
};

const ViewRecordedFuelDispenserVerificationModal = (props: IViewRecordedPricesModal) => {
  const { t } = useTranslation(['price']);
  const { isModalOpen, onCancel, formData } = props;
  const [form] = useForm();

  const [tableRecords, setTableRecords] = useState({});
  const [initialIslandLayout, setInitialIslandLayout] = useState<(IslandGrid | null)[][] | null>(
    null
  );

  const prepRecordedData = (inspectionData: any) => {
    const inspectionWithDayjsDate = {
      ...inspectionData,
      startTime: dayjs(inspectionData.startTime),
      endTime: dayjs(inspectionData.endTime),
    };
    form.setFieldsValue(inspectionWithDayjsDate);
  };

  useEffect(() => {
    if (!isModalOpen) {
      form.resetFields();
      setInitialIslandLayout([]);
      return;
    }
    prepRecordedData(formData);
    setInitialIslandLayout(formData.fuelPumpLayoutData);
    const tableData = form.getFieldValue('verificationTableData');
    setTableRecords(tableData);
  }, [isModalOpen, form]);

  return (
    <Modal
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={isModalOpen}
      onCancel={onCancel}
      footer={null}
      width={'80%'}
      destroyOnHidden={true}
      centered
    >
      <div className="view-mode-form mt-6 flex max-h-[75vh] w-full flex-col overflow-y-auto p-2 md:mt-4">
        <div className="flex w-full justify-center">
          <div className="mt-4 text-center">
            <h1 className="mb-2 text-2xl font-bold">{t('fuelDispenserVerificationMainHeading')}</h1>
            <p className="mb-2">{t('fuelDispenserVerificationSubHeading')}</p>
            <p>{t('fuelDispenserVerificationSubHeading2')}</p>
          </div>
        </div>

        <CollectionSessionInfoForm
          isViewMode={true}
          form={form}
          isModal={false}
          triggeredFromTask={false}
          taskData={{}}
          handleNext={() => {}}
          handleCancel={() => {}}
        />
        <span className="p-3"></span>
        {initialIslandLayout && (
          <>
            <FuelPumpLayout initialLayout={initialIslandLayout} isViewMode={true} />
          </>
        )}
        <div className={'m-0 w-full p-2'}>
          <Form form={form} layout="vertical">
            <Form.Item label={t('avenueAccess')} name="avenueAccess">
              <Input.TextArea disabled placeholder={t('avenueAccessPlaceholder')} />
            </Form.Item>
          </Form>
          <span className="p-3"></span>
          <FuelDispenserVerificationTable
            initialValues={tableRecords}
            isViewMode={true}
            handleCancel={() => {}}
          />
        </div>
        <span className="p-4"></span>
        <SubmitFuelDispenserVerificationForm form={form} disabled={true} isViewMode={true} />
      </div>
    </Modal>
  );
};

export default ViewRecordedFuelDispenserVerificationModal;
